module.exports = __webpack_public_path__ + "img/nature-63.140452c1.jpg";